export const CORE_LENSES = [
  {
    id: 'custom_lens',
    name: 'Custom Lens',
    description:
      'Define a custom coding framework tailored to your research objectives and data nuances.',
    category: 'Core',
    tags: ['Custom'],
    premium: false,
    // enterprise: false,
  },
  {
    id: 'grounded_emergence',
    name: 'Thematic Analysis (Grounded Emergence)',
    description:
      'Most‑popular starter lens – open‑codes your data, clusters codes into themes and visualises everything so you can understand the data fast.',
    category: 'Core',
    tags: ['Thematic'],
    premium: false,
    enterprise: false,
    // enterpriseMessage: 'Contact service@qualz.ai to learn more about this feature',
  },
];

export const PREMIUM_LENSES = [
  {
    id: 'phenomenological',
    name: 'Phenomenological Essence',
    description: 'Distil the core lived experiences expressed by participants.',
    category: 'Discover & Understand',
    tags: ['Academic', 'Research'],
    premium: true,
    isBeta: false,
  },
  {
    id: 'narrative_arc',
    name: 'Narrative Arc',
    description: 'Chart how stories unfold over time to surface tensions & resolutions.',
    category: 'Discover & Understand',
    tags: ['Academic', 'Research'],
    premium: true,
    isBeta: false,
  },
  {
    id: 'jtbd_map',
    name: 'Jobs-to-Be-Done Map',
    description: 'Identify functional, social & emotional jobs users are hiring solutions to do.',
    category: 'Design & Build',
    tags: ['Product', 'UX'],
    premium: true,
    isBeta: false,
  },
  {
    id: 'journey_pain',
    name: 'Customer-Journey Pain‑Points',
    description: 'Locate friction and delight moments along the customer journey.',
    category: 'Design & Build',
    tags: ['Product', 'UX'],
    premium: true,
    isBeta: false,
  },
  {
    id: 'persona_task',
    name: 'Persona Stem & Task Flow',
    description: 'Draft proto‑personas and the task flows they attempt.',
    category: 'Design & Build',
    tags: ['Product', 'UX'],
    premium: true,
    isBeta: false,
  },
  {
    id: 'sentiment_spectrum',
    name: 'Sentiment & Emotion Spectrum',
    description: 'Surface emotional highs & lows plus intensity hotspots.',
    category: 'Influence & Communicate',
    tags: ['Marketing', 'Comms'],
    premium: true,
    isBeta: false,
  },
  {
    id: 'framing_discourse',
    name: 'Framing & Discourse Lens',
    description: 'Reveal the metaphors and frames shaping participant perception.',
    category: 'Influence & Communicate',
    tags: ['Marketing', 'Comms'],
    premium: true,
    isBeta: false,
  },
  {
    id: 'resonance_scan',
    name: 'Message‑Resonance Scan',
    description: 'Test which messages resonate and which miss the mark.',
    category: 'Influence & Communicate',
    tags: ['Marketing', 'Comms'],
    premium: true,
    isBeta: false,
  },
  {
    id: 'outcome_barrier',
    name: 'Outcome‑Barrier Matrix',
    description: 'Contrast success enablers versus obstacles for evaluation work.',
    category: 'Evaluate & Decide',
    tags: ['Evaluator', 'Policy'],
    premium: true,
    isBeta: false,
  },
  {
    id: 'equity_audit',
    name: 'Stakeholder Equity Audit',
    description: 'Highlight who benefits and who is marginalised in findings.',
    category: 'Evaluate & Decide',
    tags: ['Evaluator', 'Policy'],
    premium: true,
    isBeta: false,
  },
  {
    id: 'toc_alignment',
    name: 'Theory‑of‑Change Alignment',
    description: 'Check alignment between findings and your logic model.',
    category: 'Evaluate & Decide',
    tags: ['Evaluator', 'Policy'],
    premium: true,
    isBeta: false,
  },
  {
    id: 'saturation_gauge',
    name: 'Saturation & Coverage Gauge',
    description: "Shows whether you've heard enough diverse voices to be confident.",
    category: 'Quality & Trust',
    tags: ['Academic', 'IRB'],
    premium: true,
    isBeta: false,
  },
  {
    id: 'reflexivity_tracker',
    name: 'Reflexivity & Bias Tracker',
    description: 'Summarise how researcher stance might shape conclusions.',
    category: 'Quality & Trust',
    tags: ['Academic', 'IRB'],
    premium: true,
    isBeta: false,
  },
];
// Routes on the qualz.ai marketing site (always the live site — there is no
// staging mirror for the static marketing pages):
//   * Guide  -> /docs/ai-analysis/{slug}      (verified against src/data/docs.ts)
//   * Learn  -> /blog/{slug}                  (verified against src/data/blog.ts)
//
// Previously these URLs used /docs/userguide/ai-analysis/... and /blogs/...
// (plural) which 404 on the marketing site — the SPA's catch-all then
// silently falls back to the landing page, so the buttons looked like they
// worked but never opened the actual content.
export const LENS_DOCS = {
  grounded_emergence: {
    userGuide: 'https://qualz.ai/docs/ai-analysis/how-to-do-thematic-analysis/',
    blog: 'https://qualz.ai/blog/what-is-grounded-theory-in-qualitative-research/',
  },
  jtbd_map: {
    userGuide: 'https://qualz.ai/docs/ai-analysis/how-to-jobs-to-be-done-analysis/',
    blog: 'https://qualz.ai/blog/what-is-the-jobs-to-be-done/',
  },
  phenomenological: {
    userGuide:
      'https://qualz.ai/docs/ai-analysis/how-to-do-phenomenological-essence-lens-analysis/',
    blog: 'https://qualz.ai/blog/phenomenological-essence-framework/',
  },
  narrative_arc: {
    userGuide: 'https://qualz.ai/docs/ai-analysis/how-to-do-narrative-arc-lens-analysis/',
    blog: 'https://qualz.ai/blog/narrative-arc-framework-qualitative-research/',
  },
  journey_pain: {
    userGuide:
      'https://qualz.ai/docs/ai-analysis/how-to-do-customer-journey-pain-point-lens-analysis/',
    // The "What is the Customer-Journey Pain-Points Framework?" blog exists
    // in the marketing repo's data but its slug contains a non-breaking
    // hyphen (%e2%80%91) that the live site doesn't route — every
    // encoding variant falls back to the landing page. Point Learn more
    // at the closest live blog ("Journey Mapping With Real Data") so the
    // button still opens a relevant article instead of being broken.
    blog: 'https://qualz.ai/blog/journey-mapping-real-data-fix-fiction/',
  },
  persona_task: {
    userGuide:
      'https://qualz.ai/docs/ai-analysis/how-to-do-the-persona-stem-task-flow-lens-analysis/',
    blog: 'https://qualz.ai/blog/what-is-the-persona-stem-and-task-flow-framework/',
  },
  sentiment_spectrum: {
    userGuide:
      'https://qualz.ai/docs/ai-analysis/how-to-do-sentiment-and-emotion-spectrum-lens-analysis/',
    blog: 'https://qualz.ai/blog/sentiment-and-emotion-spectrum/',
  },
  framing_discourse: {
    userGuide:
      'https://qualz.ai/docs/ai-analysis/how-to-do-the-framing-and-discourse-lens-analysis/',
    blog: 'https://qualz.ai/blog/what-is-framing-discourse-analysis/',
  },
  resonance_scan: {
    userGuide:
      'https://qualz.ai/docs/ai-analysis/how-to-do-the-message-resonance-scan-lens-analysis/',
    blog: 'https://qualz.ai/blog/what-is-the-message-resonance-scan-framework/',
  },
  outcome_barrier: {
    userGuide:
      'https://qualz.ai/docs/ai-analysis/how-to-do-the-outcome-barrier-matrix-lens-analysis/',
    blog: 'https://qualz.ai/blog/what-is-the-outcome-barrier-matrix-framework/',
  },
  equity_audit: {
    userGuide: 'https://qualz.ai/docs/ai-analysis/stakeholder-equity-audit-lens-analysis/',
    blog: 'https://qualz.ai/blog/what-is-the-stakeholder-equity-audit-framework/',
  },
  toc_alignment: {
    userGuide:
      'https://qualz.ai/docs/ai-analysis/how-to-do-the-theory-of-change-alignment-lens-analysis/',
    blog: 'https://qualz.ai/blog/what-is-theory-of-change/',
  },
  saturation_gauge: {
    userGuide:
      'https://qualz.ai/docs/ai-analysis/how-to-do-the-saturation-coverage-gauge-lens-analysis/',
    blog: 'https://qualz.ai/blog/what-is-the-saturation-and-coverage-framework/',
  },
  reflexivity_tracker: {
    userGuide:
      'https://qualz.ai/docs/ai-analysis/how-to-do-the-reflexivity-bias-tracker-lens-analysis/',
    blog: 'https://qualz.ai/blog/what-is-the-reflexivity-bias-tracker-framework-reflexivity-bias-tracker/',
  },
};
export const INITIAL_DISPLAY_COUNT = 8; // Initial number of lenses to display before "Load More"
export const CATEGORIES = [
  { id: 'Core', label: 'Core' },
  { id: 'Discover & Understand', label: 'Discover & Understand' },
  { id: 'Design & Build', label: 'Design & Build' },
  { id: 'Influence & Communicate', label: 'Influence & Communicate' },
  { id: 'Evaluate & Decide', label: 'Evaluate & Decide' },
  { id: 'Quality & Trust', label: 'Quality & Trust' },
];
export const TAG_THEME = {
  // Core tag themes
  Popular: {
    background: '#e3f2fd', // light blue 50
    text: '#7d5ae8', // blue 700
  },
  Thematic: {
    background: '#f3e5f5', // purple 50
    text: '#7b1fa2', // purple 700
  },
  Starter: {
    background: '#e8f5e9', // green 50
    text: '#388e3c', // green 700
  },
  Enterprise: {
    background: '#fff3e0', // orange 50
    text: '#f57c00', // orange 700
  },
  Custom: {
    background: '#fce4ec', // pink 50
    text: '#c2185b', // pink 700
  },
  Documents: {
    background: '#e0f7fa', // cyan 50
    text: '#00838f', // cyan 800
  },

  // Category tag themes
  Academic: {
    background: '#e8eaf6', // indigo 50
    text: '#303f9f', // indigo 700
  },
  Research: {
    background: '#f3e5f5', // purple 50
    text: '#7b1fa2', // purple 700
  },
  Product: {
    background: '#e0f2f1', // teal 50
    text: '#00796b', // teal 700
  },
  UX: {
    background: '#f1f8e9', // lime 50
    text: '#689f38', // lime 700
  },
  Marketing: {
    background: '#fff3e0', // orange 50
    text: '#f57c00', // orange 700
  },
  Comms: {
    background: '#ffebee', // red 50
    text: '#d32f2f', // red 700
  },
  Evaluator: {
    background: '#e0f7fa', // cyan 50
    text: '#0097a7', // cyan 700
  },
  Policy: {
    background: '#ede7f6', // deep purple 50
    text: '#512da8', // deep purple 700
  },
  IRB: {
    background: '#fce4ec', // pink 50
    text: '#c2185b', // pink 700
  },
};
// Combined list of all lenses
export const ALL_LENSES = [...CORE_LENSES, ...PREMIUM_LENSES];
